module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_donation03-845d4eafd1d6d716a036f7d64a208fe5.jpg";